<div class="app-isf-ocr-quick-fix-consignee-details">
  <div class="app-isf-ocr-quick-fix-consignee-details__header">
    <div class="app-isf-ocr-quick-fix-consignee-details__header__left">
      <p class="app-isf-ocr-quick-fix-consignee-details__header__title">
        {{ "ENTITY.CONSIGNEE" | translate | uppercase }}
      </p>

      <app-hint-tooltip-icon [hint]="'INFO.CN.SUB_TITLE' | translate"></app-hint-tooltip-icon>
    </div>
  </div>

  <div class="app-isf-ocr-quick-fix-consignee-details__row">
    <p class="app-isf-ocr-quick-fix-consignee-details__text m-0">
      {{ "INFO.CN.SUB_TITLE" | translate }}
    </p>
    <p class="app-isf-ocr-quick-fix-consignee-details__hint-text">{{ "LABELS.USE_PREV_INFO" | translate }}</p>
  </div>

  <div class="app-isf-ocr-quick-fix-consignee-details__row">
    <app-entity-unify-card
      *ngIf="!!importer && isEditMode"
      [entity]="importer"
      [formGroup]="formGroup"
      [code]="enumEntityModelCode.CONSIGNEE"
      [selectedValueControl]="formGroup.get('id')"
      [labelOverride]="'INFO.CN.USE_IM_DESKTOP'"
      [isDesktop]="isDesktop"
    ></app-entity-unify-card>
  </div>

  <div class="app-isf-ocr-quick-fix-consignee-details__row">
    <app-section-form-block-layout
      *ngIf="!!consigneeFields"
      [formGroup]="formGroup"
      [editBlockDescription]="!!importer && isEditMode ? 'LABELS.OR_ADD_DETAILS' : ''"
      [fields]="consigneeFields"
      [displayFields]="consigneeDisplayFields"
      [displayErrors]="displayErrors"
      [formErrors]="formErrors"
      [isEditBlockOpenByDefault]="isAnyFormBlockFieldEmpty(consigneeFields, formGroup)"
      [isHideBorder]="true"
      editBlockClass="normal-gap"
      (edit)="onBlockEdit($event)"
    >
      <identifier-entity-update
        edit-block-header
        [formGroup]="formGroup"
        [code]="enumEntityModelCode.CONSIGNEE"
        [type]="enumEntityType.buyer"
        [errors]="formErrors"
        [identifierFieldName]="'entityIdentifier'"
        [identifierQualifierFieldName]="'entityIdentifierQualifier'"
        [needUpdateValidators]="true"
      ></identifier-entity-update>
      <address-update
        edit-block-body
        [formGroup]="formGroup"
        [code]="enumEntityModelCode.CONSIGNEE"
        [errors]="formErrors"
        [isShowState]="true"
        [isShowCountry]="true"
        [isDesktop]="true"
        [defaultCountry]="null"
        [isFilterRestrictedCountries]="false"
      ></address-update>
    </app-section-form-block-layout>
  </div>

  <ng-container *ngIf="isEditMode">
    <hr class="app-isf-ocr-quick-fix-consignee-details__hr" />

    <div class="app-isf-ocr-quick-fix-consignee-details__clear-form-btn" (click)="onClearForm()">
      <i class="fa fa-trash btn-remove-icon"></i>
      {{ "FORM_LABEL.CLEAN_FORM" | translate }}
    </div>
  </ng-container>

  <missing-fields [code]="'LABELS.ISF'" (decline)="onSubmit(false)"></missing-fields>
</div>
